import { toast } from '@kalos/ui';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { z } from 'zod';

import { CostReportCSV } from '../modules/ComponentsLibrary/CostReportCSV';

export const Route = createFileRoute('/cost-report/$jobNumber')({
  component: CostReportPage,
  params: z.object({
    jobNumber: z.coerce.number().positive(),
  }),
  loader(ctx) {
    const hasCostReportAccess = ctx.context.authContext.user.permissionGroups.some(
      (group) => group.name === 'CostReportAccess',
    );
    if (!hasCostReportAccess) {
      toast({
        title: 'Access Denied',
        description:
          'You do not have permission to view cost reports. Please contact your administrator if you believe this is an error.',
        variant: 'destructive',
      });
      throw redirect({ to: '/' });
    }
  },
  head(ctx) {
    return {
      meta: [{ title: `Cost Report | Job #${ctx.params.jobNumber}` }],
    };
  },
});

function CostReportPage() {
  const { jobNumber } = Route.useParams();
  return (
    <div className="theme-light min-h-screen">
      <CostReportCSV title="Job Cost Report" serviceCallId={jobNumber} />
    </div>
  );
}
